export default "__VITE_ASSET__BtNmpz5K__"